<template>
  <el-dialog title="New Case" :visible.sync="visible" width="70%" :close-on-click-modal="false" append-to-body>
      <el-form :model="form" :rules="rules" ref="form" label-position="top" size="mini">

        <!-- Header Info -->
         <el-row :gutter="20">
             <el-col :span="6">
                 <el-form-item label="Case Number">
                     <el-input v-model="form.caseNumber" disabled placeholder="Auto Generated"></el-input>
                 </el-form-item>
             </el-col>
              <el-col :span="6">
                 <el-form-item label="Caller Type" prop="callerType">
                     <caller-type-select v-model="form.callerType" :disabled="shouldDisableCallerType" />
                 </el-form-item>
             </el-col>
              <el-col :span="6">
                 <el-form-item label="Caller Name" prop="callerName">
                     <el-input v-model="form.callerName"></el-input>
                 </el-form-item>
             </el-col>
               <el-col :span="6">
                 <el-form-item label="Status" prop="statusClaim">
                     <status-claim-select v-model="form.statusClaim" disabled />
                 </el-form-item>
             </el-col>
         </el-row>

          <el-divider content-position="left">
            <span class="title-list">{{ $t('casesAndClaims.shipmentDetails') }}</span>
          </el-divider>

          <el-row :gutter="20">
               <el-col :span="6">
                   <el-form-item label="Load Number">
                       <el-input v-model="form.loadNumber" disabled></el-input>
                   </el-form-item>
               </el-col>
                <el-col :span="6">
                   <el-form-item label="Bill Of Lading">
                       <el-input v-model="form.billOfLanding" disabled></el-input>
                   </el-form-item>
               </el-col>
                <el-col :span="6">
                   <el-form-item label="Invoice Number">
                       <el-input v-model="form.invoiceNumber" disabled></el-input>
                   </el-form-item>
               </el-col>
                <el-col :span="6">
                   <el-form-item label="Pickup Date">
                       <el-date-picker v-model="form.pickupDate" type="date" disabled style="width:100%"></el-date-picker>
                   </el-form-item>
               </el-col>
          </el-row>
           <el-row :gutter="20">
               <el-col :span="6">
                   <el-form-item label="Shipment">
                       <el-input v-model="form.shipmentNumber" disabled></el-input>
                   </el-form-item>
               </el-col>
                <el-col :span="6">
                   <el-form-item label="Shipper">
                       <master-record-autocomplete
                            :model.sync="form.shipper"
                            :url="urlShipper"
                            labelField="name"
                            popperAppendToBody
                            labelFieldLastWithDash="number"
                            valueField="id"
                            :edit-value="shipperNameToEdit"
                            disabled
                        />
                   </el-form-item>
               </el-col>
                <el-col :span="6">
                   <el-form-item label="Consignee">
                       <master-record-autocomplete
                            :model.sync="form.consignee"
                            :url="urlConsignee"
                            labelField="name"
                            popperAppendToBody
                            labelFieldLastWithDash="number"
                            valueField="id"
                            :edit-value="consigneeNameToEdit"
                            disabled
                        />
                   </el-form-item>
               </el-col>

         <!-- Bill To -->
             <el-col :span="6">
                 <el-form-item label="Bill To" prop="billTo">
                     <master-record-autocomplete
                        :model.sync="form.billTo"
                        :url="urlBillTo"
                        placeholder="Search Bill To"
                        labelField="name"
                        popperAppendToBody
                        labelFieldLastWithDash="number"
                        valueField="id"
                        :edit-value="billToNameToEdit"
                        disabled
                     />
                 </el-form-item>
             </el-col>
           </el-row>

           <el-divider content-position="left">
              <span class="title-list">{{ $t('casesAndClaims.additionalInformation') }}</span>
            </el-divider>
             <el-row :gutter="20">
               <el-col :span="6">
                    <el-form-item label="Type" prop="type">
                         <case-type-select v-model="form.type" />
                    </el-form-item>
               </el-col>

                <!-- Inquiry Reason -->
                <el-col :span="6" v-if="isTypeInquiry">
                    <el-form-item label="Inquiry" prop="caseReasonInquiry">
                         <el-input v-model="form.caseReasonInquiry" placeholder="Inquiry notes"></el-input>
                    </el-form-item>
                </el-col>

                <!-- Maintenance Reason -->
                 <el-col :span="6" v-if="isTypeMaintenance">
                    <el-form-item label="Maintenance" prop="caseReasonMaintenance">
                         <maintenance-select v-model="form.caseReasonMaintenance" />
                    </el-form-item>
                </el-col>
                 <el-col :span="6" v-if="isTypeMaintenanceAndOther">
                    <el-form-item label="Maintenance Notes" prop="maintenanceNotes">
                         <el-input v-model="form.maintenanceNotes"></el-input>
                    </el-form-item>
                </el-col>

                <!-- Report Reason -->
                 <el-col :span="6" v-if="isTypeReport">
                    <el-form-item label="Report" prop="caseReasonReport">
                         <report-select v-model="form.caseReasonReport" />
                    </el-form-item>
                </el-col>
                 <el-col :span="6" v-if="isTypeReportAndOther">
                    <el-form-item label="Report Notes" prop="reportNotes">
                         <el-input v-model="form.reportNotes"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="Subject">
                         <el-input v-model="form.subject"></el-input>
                    </el-form-item>
               </el-col>
                <!-- el-col :span="6">
                    <el-form-item label="Case Origin">
                         <case-origin-select v-model="form.caseOrigin" />
                    </el-form-item>
               </el-col>
               <el-col :span="6">
                    <el-form-item label="Priority">
                         <priority-select v-model="form.priority" />
                    </el-form-item>
               </el-col -->
             </el-row>

              <el-divider content-position="left">
                <span class="title-list">{{ $t('casesAndClaims.descriptionInformation') }}</span>
              </el-divider>
              <el-row :gutter="20">
                   <el-col :span="12">
                        <el-form-item label="Description">
                            <el-input type="textarea" v-model="form.description"></el-input>
                        </el-form-item>
                   </el-col>
              </el-row>

               <el-divider content-position="left">
                <span class="title-list">{{ $t('casesAndClaims.amount') }}</span>
              </el-divider>
                <el-row :gutter="20">
              <el-col :span="6">
                   <el-form-item label="Amount">
                       <el-input type="number" v-model="form.amount" placeholder="0.00"></el-input>
                   </el-form-item>
              </el-col>
          </el-row>
        <el-row>
          <!--                  FILE UPLOAD-->
          <el-col :span="12" class="form-vertical-item">
            <el-form-item :label="$t('casesAndClaims.files')" prop="files" ref="files">
              <upload-files ref="upload-files" :case-id="form.id" :internal="isInternal" :can-edit="true" :file-list.sync="fileList" />
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
            <el-button type="primary" @click="handleSave" :loading="loading">{{ $t('common.save') }}</el-button>
        </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import casesAndClaimsService from '@/api/casesAndClaims';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import CallerTypeSelect from '@/views/customerCenter/casesAndClaims/components/callerTypeSelect/CallerTypeSelect';
import StatusClaimSelect from '@/views/customerCenter/casesAndClaims/components/statusClaimSelect/StatusClaimSelect';
import MasterRecordAutocomplete from '@/views/customerCenter/components/autocomplete/MasterRecordAutocomplete';
import CaseTypeSelect from '@/views/customerCenter/casesAndClaims/components/caseTypeSelect/caseTypeSelect';
import MaintenanceSelect from '@/views/customerCenter/casesAndClaims/components/maintenanceSelect/MaintenanceSelect';
import ReportSelect from '@/views/customerCenter/casesAndClaims/components/ReportSelect/ReportSelect';
import UploadFiles from '@/views/customerCenter/casesAndClaims/components/history/UploadFiles';
// import CaseOriginSelect from '@/views/customerCenter/casesAndClaims/components/caseOriginSelect/CaseOriginSelect';
// import PrioritySelect from '@/views/customerCenter/casesAndClaims/components/prioritySelect/PrioritySelect';

export default {
  name: 'ClientAddCaseModal',
  components: {
    CallerTypeSelect,
    StatusClaimSelect,
    MasterRecordAutocomplete,
    CaseTypeSelect,
    MaintenanceSelect,
    ReportSelect,
    UploadFiles,
    // CaseOriginSelect,
    // PrioritySelect
  },
  data() {
    return {
      visible: false,
      loading: false,
      urlBillTo: apiConstants.END_POINTS.ACCOUNTS.BILL_TO,
      urlShipper: '/accounts/', // apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
      urlConsignee: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE,
      billToNameToEdit: null,
      shipperNameToEdit: null,
      consigneeNameToEdit: null,
      fileList: [],
      form: {
        caseNumber: null,
        callerType: this.callerTypeInitialValue,
        callerName: null,
        statusClaim: 1,
        billTo: null,
        loadNumber: null,
        billOfLanding: null,
        invoiceNumber: null,
        pickupDate: null,
        shipmentNumber: null,
        shipper: null,
        consignee: null,
        type: null,
        caseReasonInquiry: null,
        caseReasonMaintenance: null,
        maintenanceNotes: null,
        caseReasonReport: null,
        reportNotes: null,
        subject: null,
        caseOrigin: 3,
        priority: null,
        amount: null,
        description: null,
        internalComments: null,
        shipmentId: null
      },
      rules: {
        callerType: [{ required: true, message: 'Required', trigger: 'change' }],
        callerName: [{ required: true, message: 'Required', trigger: 'blur' }],
        type: [{ required: true, message: 'Required', trigger: 'change' }],
        caseReason: [{ required: true, message: 'Required', trigger: 'change' }],
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form.callerType = this.callerTypeInitialValue;
    });
  },
  computed: {
    ...mapGetters(['isInternalUser',
      'isShipperUser',
      'isConsigneeUser']),
    isInternal() {
      return this.isInternalUser;
    },
    callerTypeInitialValue() {
      if (this.isShipperUser) {
        return constants.CASES_AND_CLAIMS.CALLER_TYPE.find(item => item.label === 'Shipper').value;
      }
      if (this.isConsigneeUser) {
        return constants.CASES_AND_CLAIMS.CALLER_TYPE.find(item => item.label === 'Consignee').value;
      }
      return null;
    },
    shouldDisableCallerType() {
      return this.isShipperUser || this.isConsigneeUser;
    },
    isTypeInquiry() {
      const typeObj = constants.CASES_AND_CLAIMS.CASE_TYPE.find(item => item.label === 'Inquiry');
      return typeObj && this.form.type === typeObj.value;
    },
    isTypeMaintenance() {
      const typeObj = constants.CASES_AND_CLAIMS.CASE_TYPE.find(item => item.label === 'Maintenance');
      return typeObj && this.form.type === typeObj.value;
    },
    isTypeMaintenanceAndOther() {
      const maintOtherObj = constants.CASES_AND_CLAIMS.MAINTENANCE_TYPE.find(item => item.label === 'Other');
      return this.isTypeMaintenance && maintOtherObj && this.form.caseReasonMaintenance === maintOtherObj.value;
    },
    isTypeReport() {
      const typeObj = constants.CASES_AND_CLAIMS.CASE_TYPE.find(item => item.label === 'Report');
      return typeObj && this.form.type === typeObj.value;
    },
    isTypeReportAndOther() {
      const reportOtherObj = constants.CASES_AND_CLAIMS.REPORT_TYPE.find(item => item.label === 'Other');
      return this.isTypeReport && reportOtherObj && this.form.caseReasonReport === reportOtherObj.value;
    }
  },
  methods: {
    open(shipmentData) {
      this.visible = true;
      this.initForm();

      if (shipmentData) {
        this.form.loadNumber = shipmentData.loadNumber || '';
        this.form.billOfLanding = shipmentData.bolNumber || '';
        this.form.invoiceNumber = shipmentData.invoiceNumber || '';
        this.form.pickupDate = shipmentData.pickupDate ? new Date(shipmentData.pickupDate) : new Date(shipmentData.outboundDate);
        this.form.shipmentNumber = shipmentData.shipmentNumber || '';
        this.form.shipmentId = shipmentData.id;

        this.form.billTo = shipmentData.billToAccountId;
        this.billToNameToEdit = shipmentData.billToAccountName;

        this.form.shipper = shipmentData.shipperAccountId;
        this.shipperNameToEdit = shipmentData.shipperAccountName;

        this.form.consignee = shipmentData.consigneeAccountId;
        this.consigneeNameToEdit = shipmentData.consigneeAccountName;
      }
    },
    initForm() {
      this.form = {
        caseNumber: null,
        callerType: this.callerTypeInitialValue,
        callerName: null,
        statusClaim: 1,
        billTo: null,
        loadNumber: null,
        billOfLanding: null,
        invoiceNumber: null,
        pickupDate: null,
        shipmentNumber: null,
        shipper: null,
        consignee: null,
        type: null,
        caseReasonInquiry: null,
        caseReasonMaintenance: null,
        maintenanceNotes: null,
        caseReasonReport: null,
        reportNotes: null,
        subject: null,
        caseOrigin: 3,
        priority: null,
        amount: null,
        description: null,
        internalComments: null,
        shipmentId: null
      };
      this.billToNameToEdit = null;
      this.shipperNameToEdit = null;
      this.consigneeNameToEdit = null;
      if (this.$refs.form) this.$refs.form.resetFields();
      this.fileList = [];
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const webEmail = this.$store.state.user.email || '';
          const payload = { ...this.form, webEmail };
          if (!webEmail || webEmail.trim() === '') {
            this.$message.error('User email is required to create a case');
            this.loading = false;
            return;
          }
          casesAndClaimsService.save(payload)
            .then((response) => {
              this.$message.success(response.message);
              this.form.id = response.caseAndClaimId;
              this.$refs['upload-files'].submitIfPossible(response.caseAndClaimId);
              this.$emit('saved');
              this.visible = false;
            })
            .catch((error) => {
              if (!error.message) {
                this.$message.error('Error creating case');
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.title-list {
  display: inline-block;
}
</style>
